<div class="report-main">

  <!-- Buttons -->
  <div class="action-buttons noPrint">

    <button
      mat-raised-button
      color="primary"
      (click)="printPageA4()">
      Print
    </button>

    <button
      mat-raised-button
      color="accent"
      (click)="exportExcel('dispatchwise_report')">
      Export
    </button>

    <button
      mat-raised-button
      color="warn"
      mat-dialog-close>
      Close
    </button>

  </div>

  <!-- Report Section -->
  <div id="print-section" class="table-container">

    <table class="report-table">

      <thead>
        <tr>
          <th colspan="7" class="report-title">
            Dispatch Vitaran Report
          </th>
        </tr>

        <tr>
          <th>Sr No</th>
          <th>Seller Name</th>
          <th>Taluka</th>
          <th>District</th>
          <th>Book Copies</th>
          <th>Representative</th>
          <th>Dist Mode</th>
        </tr>
      </thead>

      <tbody>

        <ng-container *ngIf="sellerData && sellerData.length > 0; else noData">

          <tr *ngFor="let item of sellerData; let i = index; trackBy: trackByIndex">
            <td>{{ i + 1 }}</td>
            <td>{{ item.subscribers_name }}</td>
            <td>{{ item.taluka }}</td>
            <td>{{ item.district }}</td>
            <td>{{ item.book_copies }}</td>
            <td>{{ item.rep_name }}</td>
            <td>{{ item.DeliveryMode }}</td>
          </tr>

          <!-- TOTAL ROW -->
          <tr style="font-weight:bold; background:#f3f3f3;">
            <td colspan="4">TOTAL</td>
            <td>{{ totalCopies }}</td>
            <td></td>
            <td></td>
          </tr>

        </ng-container>

        <!-- NO DATA -->
        <ng-template #noData>
          <tr>
            <td colspan="7" class="no-data">
              No Data Found
            </td>
          </tr>
        </ng-template>

      </tbody>

    </table>

  </div>

</div>

<!-- Loader -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>